<template>
  <div class="pawpulse-service-section">
    <div class="background-container">
    </div>

    <div class="content-container">
      <div class="content">
        <div class="header-section">
          <h1 class="section-title">{{ translate('landing.pawpulse_service', 'PAWPULSE') }}</h1>
          <h2 class="main-description">
            {{ translate('landing.pawpulse_description', 'Real-time customer feedback solution for pet businesses') }}
          </h2>
        </div>
        
        <!-- Sección de beneficios y dashboard -->
        <div class="benefits-dashboard-section">
          <div class="content-row">
            <div class="benefits-column">
              <div class="benefits-content">
                <p class="benefits-intro">{{ translate('landing.benefits_intro', 'By collecting real-time feedback, you can:') }}</p>
                <ul class="benefits-list">
                  <li>{{ translate('landing.benefit_1', 'Address concerns before escalation') }}</li>
                  <li>{{ translate('landing.benefit_2', 'Enhance customer experience') }}</li>
                  <li>{{ translate('landing.benefit_3', 'Encourage repeat business') }}</li>
                </ul>
              </div>
            </div>
            <div class="dashboard-column" >
              <img src="@/assets/technopawsImages/pawpulseDashboard.png" alt="PawPulse Dashboard" class="dashboard-image">
            </div>
            <div class="action-column">
              <a @click="goToHome" class="cta-button button">{{ translate('landing.free_demo', 'FREE DEMO') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { useStore } from 'vuex'

export default {
  name: 'PawpulseServiceSection',
  setup() {
    const store = useStore()
    
    const translate = (key, fallback) => {
      const translations = store.state.translations
      const parts = key.split('.')
      
      let value = translations
      for (const part of parts) {
        if (value && value[part]) {
          value = value[part]
        } else {
          return fallback
        }
      }
      
      return typeof value === 'string' ? value : fallback
    }
    
    return {
      translate
    }
  },
  methods: {
    scrollToContact() {
      const contactSection = document.getElementById('contact')
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' })
      }
    },
    goToHome() {
      this.$router.push('/home');
    }
  }
}
</script>

<style scoped>

:root {
  /* Variables globales si son necesarias */
}

.pawpulse-service-section {
  width: 100%;
  height: 100%;
  min-height: 100%;
  position: relative;
  align-items: center;
  color: #09405c;
  overflow: hidden;
}

/* Contenedor para el fondo */
.background-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/technopawsImages/pawpulse.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #09405c;
  z-index: 1;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  overflow-y: auto; /* Permitir scroll vertical si el contenido excede la altura */
  scrollbar-width: thin; /* Para Firefox */
  scrollbar-color: rgba(9, 64, 92, 0.5) transparent; /* Para Firefox */
}

.header-section {
  text-align: center;
  margin-bottom: 2rem;
}

.section-title {
  color: #09405c; /* Sobreescribimos el color para este componente */
  margin: 0;
  margin-bottom: 0.5rem;
  letter-spacing: 1px;
}

.main-description {
  color: #09405c; /* Sobreescribimos el color para este componente */
}

.content-row {
  display: flex;
  gap: 1.5rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.benefits-column, .dashboard-column, .action-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.benefits-column {
  flex: 1;
  min-width: 280px;
}

.dashboard-column {
  flex: 2;
  min-width: 300px;
}

.action-column {
  flex: 0 0 auto;
  min-width: 150px;
}

.benefits-content {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.benefits-intro {
  font-weight: bold;
  margin-bottom: 1rem;
  color: #09405c;
}

.benefits-list {
  padding-left: 1.5rem;
  margin: 0;
}

.benefits-list li {
  margin-bottom: 0.8rem;
  color: #09405c;
}

.dashboard-image {
  width: 100%;
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-section {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
}

.cta-button {
  background-color: #4a9d76;
}

/* Navegación */
.navigation-section {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 10;
  padding: 0.5rem;
  border-radius: 20px;
}

.nav-button {
  display: flex;
  align-items: center;
  background-color: #09405c;
  border: 1px solid #09405c;
  border-radius: 20px;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  gap: 0.5rem;
  padding: 0.7rem 1.2rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  text-decoration: none;
}

.nav-button:hover {
  background-color: #0c5a81;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.next-button i {
  font-size: 1.3rem;
  margin-left: 0.3rem;
}

/* Media queries para móviles rcpequeños */
@media (max-width: 480px) {
  .pawpulse-service-section {
    min-height: auto;
    padding: 3rem 0;
  }

  .background-container {
    background-position: center top;
    background-size: 290% auto
  }
  
  .content {
    margin: 0rem;
    overflow-y: auto;
    max-height: 100vh;
  }

  .content-row {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 2em; 
    justify-content: space-around;
  }

  .header-section {
   text-align: center;
   margin-bottom: 0rem;
}

  .section-title {
    margin-bottom: 0;
    letter-spacing: 0px;
  }
  
  .main-description {
   padding: 1rem 1rem;
  }
  
  .benefits-content {
    font-size: 1.25rem;
    margin: 0;
    padding: 1rem 1rem;
    line-height: 1.6;
    background-color: #549f93;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)
  }
  
  .benefits-list {
    padding: 1rem;
    font-size: 1.25rem;
    margin-bottom: 0rem;
  }
  
  .benefits-intro {
    margin-bottom: 0rem;
  }

  .benefits-column {
    flex: 1 1 100%;
    order: 1;
  }

  .dashboard-column {
    flex: 1 1 60%;
    order: 2;
  }
  
  .action-column {
    flex: 1 1 30%;
    order: 3;
  }
  
  .dashboard-image {
    max-height: 40vh;
    margin: 0rem
  }
}
</style>
